export default __webpack_public_path__ + "static/media/3.42df4b4b.svg";